import { ControlledSelectField } from 'components/Form';
import type { WorkOrderSeasonData } from 'gql/graphql';
import { requiredBaseRule } from 'utils/constants';

import { useMemo } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useSeasons } from '../hooks/useSeasons';

import { getActKC2SeasonLabel } from './ActKC2SeasonField';

interface IActKC2InflationSeason extends UseControllerProps {
    disabled: boolean;
    seasonIdValue: number;
}

export const ActKC2InflationSeason = ({ name, control, disabled, seasonIdValue }: IActKC2InflationSeason) => {
    const { orderId } = useParams();
    const [seasons] = useSeasons(Number(orderId), false, 'actSeasons');

    const currentSeasonYear = useMemo(
        () => seasons.find((s) => s.id === seasonIdValue)?.year,
        [seasonIdValue, seasons],
    );

    const seasonsItems = useMemo(
        () =>
            seasons
                .filter((s) => s.year <= currentSeasonYear)
                .map(({ id, year }: WorkOrderSeasonData) => ({
                    id,
                    label: getActKC2SeasonLabel(year),
                })),
        [currentSeasonYear, seasons],
    );

    return (
        <ControlledSelectField
            disabled={disabled}
            name={name}
            label="Сезон начисления инфляции"
            control={control}
            items={seasonsItems}
            required={!disabled}
            rules={requiredBaseRule}
            className="SelectFieldActRC2"
        />
    );
};

ActKC2InflationSeason.displayName = 'ActKC2InflationSeason';
